

import { components, bindingHandlers } from 'knockout'

// utils
import { debounce, escapeRegExpString, newDomElement, proxySet } from '@utils/Misc'





// from url, no jquery
const fromPathTemplateLoader = {
    loadTemplate: (name: string, config: any, callback: (result: Node[]) => void) => {

        if (config.path) {

            let { path, ext = '', maxCacheAge, route = '/template', } = config,
                query = `?path=${ path }${ ext ? '?ext=' + ext : '' }${ maxCacheAge ? '?maxCacheAge=' + maxCacheAge : '' }`,
                markupString = '[[Not Loaded]]'

            fetch(route + query)
                .then(async (res: Response) => {
                    if (res.status === 200)
                        markupString = await res.text()
                })
                .catch((err: any) => {
                    throw new Error('Failed to load template', { cause: err })
                })
                .finally(() => {
                    components.defaultLoader.loadTemplate(name, markupString, callback)
                })
        }
        else
            callback(null)
    }
}

components.loaders.unshift(fromPathTemplateLoader)


// replaces <slot/> element in template with $componentTemplateNodes | ComponentInfo.templateNodes
// TODO: named slots. see behaviour in vue
const useSlots = (rootEl: HTMLElement, nodes: Node[]) => {
    rootEl.querySelector('slot')?.replaceWith(...nodes)
},
    useSlotsLoader = {
        loadViewModel: (name: string, config: any, callback: (result: any) => void) => {

            if (config.useSlots) {

                let viewModelConstructor = (params: any, root: ExtendedComponentInfo) => {

                    root.templateNodes.length > 0 &&
                        useSlots(root.element, root.templateNodes)

                    return new config.useSlots(params, root.element)
                }

                components.defaultLoader.loadViewModel(name, { createViewModel: viewModelConstructor }, callback)
            }
            else
                callback(null)
        }
    }

components.loaders.unshift(useSlotsLoader)






// simplified element references registration
bindingHandlers.ref = {
    init: (el, val, bindings, _, ctx) => {
        let name = val(),
            setup = bindings().refSetup

        if (ctx.$component) {
            ctx.$component.$refs ||= {}
            ctx.$component.$refs[ name ] = el
        }

        setup && setup(name, el)
    }
}


// mark invalid inputs
bindingHandlers.pw_validate = {
    update: (el, val, _, __, ctx) => {
        let valid = val().valid

        !ctx.$component.base.showInvalid()
            || typeof valid === 'function'
            && valid()
                ? el.classList.remove('input-invalid')
                : el.classList.add('input-invalid')
    }
}






const autocomplete_cache: {
    [ k: string ]: {
        values: string[],
        timestamp: number
    }
} = {},
/** runtime cache? -> session storage? -> fetch -> runtime cache -> session starage */
autocomplete_get = (val: string, endpoint: string, property: number, datatype:string, key:string, len: number = 10, expire: number = 300_000) => {
    let cachekey = `prop[${ property }]_datatype[${datatype}]_key[${key}]_key[${ val?.replace(/\s/g, '_') }]`
            
    // see if cached results exist in storage
    if (!autocomplete_cache[ cachekey ]) {
        let storageEntry = sessionStorage.getItem(cachekey)
            
        if (storageEntry)
            autocomplete_cache[ cachekey ] = JSON.parse(storageEntry)
    }

    if (!autocomplete_cache[ cachekey ] || autocomplete_cache[ cachekey ].timestamp - Date.now() > expire) {
        if (!val) return []

        // TODO: error handling
        return new Promise<any[]>((res: any, rej: any) => {
            debounce(() => {
                let query ='?';
                query +=property?`property=${ property }`:'';
                query +=datatype!=undefined?`&type=${ datatype }`:'';
                query +=key?`&key=${ key }`:'';
                
                query +=`&value=${ val }&take=${ len }`

                $.fn.application.get(endpoint + query)
                    .then((result: string[]) => {
                        
                        let mapped = [];
                        for(var ix=0;ix<result.length;ix++){  
                            mapped = [...mapped,...result[ix].split(',')];
                        }
                        mapped = [...new Set(mapped)].filter(item=>item.toUpperCase().indexOf(val.toUpperCase())>-1);
                        // store results (including empty)
                        autocomplete_cache[ cachekey ] = {
                            values: mapped,
                            timestamp: Date.now()
                        }
                        sessionStorage.setItem(cachekey, JSON.stringify(autocomplete_cache[ cachekey ]))

                        res(mapped)
                    })

            }, { delay: 200 })  // needs to be enought to not spam the api 
        })
    }
    else {
        return autocomplete_cache[ cachekey ].values
    }
}


export const assertPersmissionLevel = (scopes: { Feature: string, Permission: number, Executable: boolean }[], req_permissions: string[], req_level: number): boolean => {
    for (let scope of scopes)
        if (req_permissions.indexOf(scope.Feature) + 1 && scope.Permission < req_level)
            return false

    return true
}

const REQ_PERMISSIONS = [ 'Any', 'Issues', 'Sms', 'Contacts', 'Surveys', 'Events', 'Tags', 'Lists', 'Segments', 'Journeys' ],
    REQ_LEVEL = 1
bindingHandlers.autocomplete = {
    init: (el, val: KnockoutComputed<{ props, property, datatype, key, endpoint, listLength, expireCache, rootContainer: HTMLElement | any, container: HTMLElement | any,  }>, bindings, _, ctx) => {

        let user = ko.unwrap(ctx.$root?.CurrentUser ?? viewModel.CurrentUser)
        if (!assertPersmissionLevel(ko.mapping.toJS(user.AuthorizedForScopes), REQ_PERMISSIONS, REQ_LEVEL))
            return

        const { props, property, datatype, key, endpoint, listLength = 10, expireCache = 300_000, rootContainer, container } = val(),
            { value } = bindings();
        console.log('autocomplete init',property,datatype,key,endpoint);
        
        let compositeKey = `${!!property?'prop'+property():''}`;
        compositeKey += `${!!datatype?'dt'+datatype():''}`;
        compositeKey +=`${!!key?'k'+key():''}`;
        compositeKey +=`${'ep' +endpoint}`;
        console.log('compositeKey',compositeKey);
        let indicator = newDomElement('div', { classes: 'working-indicator btm' }),
            list = rootContainer.dropdown?.list ?? {
                key: compositeKey,
                el: newDomElement('div'),
                items: []
            }


        let dropdown = rootContainer.dropdown

        if (!dropdown || !rootContainer.hasChildNodes(dropdown)) {

            let newDropdown = newDomElement('div', {
                classes: 'autocomplete-dropdown',
            })
                

            newDropdown.appendChild(list.el)
            newDropdown[ 'list' ] = list

            // TODO: allow definition of container in options
            rootContainer.appendChild(newDropdown)
            rootContainer.dropdown =
                dropdown = newDropdown
        }
        el.insertAdjacentElement('afterend', indicator)


        /** sets dropdown position css custom properties */
        const updateCustomProps = () => {

            let ac_width = el.offsetWidth
            if (ac_width !== dropdown.width_lastValue) {

                dropdown.width_lastValue = ac_width

                rootContainer.setAttribute('style',
                    `--ac-width: ${ ac_width }px`)
            }


            let elRect = el.getBoundingClientRect(),
                containerRect = rootContainer.getBoundingClientRect(),
                dd_height = dropdown.offsetHeight,
                dd_top = (elRect.bottom + dd_height >= window.innerHeight ? elRect.top - dd_height : elRect.bottom) - containerRect.top,
                dd_left = elRect.left - containerRect.left


            if (dd_top !== dropdown.top_lastValue || dd_left !== dropdown.left_lastValue) {

                dropdown.top_lastValue = dd_top
                dropdown.left_lastValue = dd_left

                rootContainer.setAttribute('style',
                    `--ac-width: ${ ac_width }px;
                    --ac-dropdown-top: ${ dd_top }px;
                    --ac-dropdown-left: ${ dd_left }px`)
            }
        }


        // state handlers
        const setListItems = async (val: string) => {
            let prop =  !!property?property():null;
            let scopetype = !!datatype?datatype():null;
            let scopekey = !!key?key():null;
            if (isNaN(prop)) return

            // pre-fetch filter might yield and empty list
            if (compositeKey === list.property && val && list.items.length)
                state.open ||= true
            else
                state.open &&= false


            state.mark = 0
            list.items[ state.mark ]?.el.classList.add('marked')  // mark in case state value is unchanged
            val && indicator.classList.add('active')


            // important to not set any listeners or add any references to the list & list items
            // so that discarded elements get garbage collected. alt: reuse, reduce, recycle
            let newList = newDomElement('div'),
                results = await autocomplete_get(val, endpoint, prop, scopetype,scopekey, listLength, expireCache)

            list.items = []
            for (let i = 0; i < results.length; i++) {
                let el = newDomElement('div', { classes: 'autocomplete-option' })

                el.innerText = results[ i ]
                el.dataset.slot = i.toString()
                i === state.mark &&
                    el.classList.add('marked')

                list.property = compositeKey;
                list.items.push({
                    el,
                    value: results[ i ]
                })

                newList.appendChild(el)
            }


            // reflect state after fetch results, !! val is the same as before await
            if (el === document.activeElement && state.value && list.items.length)
                state.open ||= true
            else
                state.open &&= false

            dropdown.replaceChild(newList, dropdown.list.el)
            dropdown.list.el = newList  // clear reference to the old list

            indicator.classList.remove('active')

            updateCustomProps()
        }


        const state_handlers = {
            open: (val: boolean) => {
                val ? dropdown.classList.add('dis-bl')
                    : dropdown.classList.remove('dis-bl')
            },
            value: async (val: string) => {

                // remove non-matching & fully matching entries from list pre-fetch
                let regexp = new RegExp('^' + escapeRegExpString(val), 'i')
                for (let i = 0; i < list.items.length; i++) {
                    if (!regexp.test(list.items[ i ].value) || val === list.items[ i ].value.trim()) {
                        list.items[ i ].el.remove()
                        list.items.splice(i--, 1)
                    }
                }


                setListItems(val)
                value(val)
            },
            mark: (val: number) => {
                list.items[ state.mark ]?.el.classList.remove('marked')
                list.items[ val ]?.el.classList.add('marked')
            }
        }


        // state reactive props
        const state = proxySet({
            open: false,
            value: value(),
            mark: 0
        }, state_handlers)

        //
        // property.computed ||= ko.computed({
        //     read: () => {
        //         if (typeof property.old === 'undefined')
        //             property.old = property()
        //
        //         // reset input value on input type change
        //         if (typeof property() !== 'undefined' && props[ property() ]?.InputType !== props[ property.old ]?.InputType) {
        //             property.old = property()
        //
        //             value(state.value = '')
        //         }
        //     },
        //     disposeWhenNodeIsRemoved: container
        // })



        const updateValue = () => {
            state.value = list.items[ state.mark ].value
        }

        // event methods
        const handleInput = () => {
            if (list.items.length)
                state.open ||= true

            state.value = el.value
        }

        const handleListActions = (ev: KeyboardEvent) => {
            if (ev.key === 'ArrowUp') {
                ev.preventDefault()

                state.mark > 0 && --state.mark
            }

            if (ev.key === 'ArrowDown') {
                ev.preventDefault()

                state.mark < list.items.length-1 && ++state.mark
            }

            if (ev.key === 'Enter' && state.value) {
                ev.preventDefault()

                updateValue()
            }
        }

        const handleHover = (ev: MouseEvent & { target: HTMLElement }) => {
            ev.stopPropagation()

            let slot = parseInt(ev.target.dataset.slot)

            if (isNaN(slot)) return

            if (slot !== state.mark)
                state.mark = slot
        }


        // events
        el.addEventListener('focus', () => {

            state.value &&
                setListItems(state.value)

            el.addEventListener('input', handleInput)
            el.addEventListener('keydown', handleListActions)
            el.addEventListener('mousedown', updateCustomProps)
            dropdown.addEventListener('mousedown', updateValue)
            dropdown.addEventListener('mousemove', handleHover)


            el.addEventListener('blur', () => {
                el.blur()  // assert blur, case interaction outside of document
                state.open &&= false

                el.removeEventListener('input', handleInput)
                el.removeEventListener('keydown', handleListActions)
                el.removeEventListener('mousedown', updateCustomProps)
                dropdown.removeEventListener('mousedown', updateValue)
                dropdown.removeEventListener('mousemove', handleHover)

            })
        })
    }
}